import type { ArRowData, ArRowId, TypeId } from '#types/System.Artifacts.types';
import type { DocEntry } from '../../../store/Store.types';

const getCellDisplayValue = (cellValue: unknown): string => {
  if (cellValue === null || cellValue === undefined) return '';
  if (typeof cellValue === 'string') return cellValue;
  if (typeof cellValue === 'number' || typeof cellValue === 'boolean') return String(cellValue);
  if (Array.isArray(cellValue)) return cellValue.map(String).join(', ');

  if (typeof cellValue === 'object' && cellValue !== null) {
    const obj = cellValue as Record<string, unknown>;
    if (typeof obj.cacheLabel === 'string' && obj.cacheLabel.length > 0) return obj.cacheLabel;
    if (typeof obj.docId === 'string' && obj.docId.length > 0) return obj.docId;
  }

  return String(cellValue);
};

const rowMatchesFilters = (
  rowData: ArRowData | undefined,
  filterEntries: ReadonlyArray<readonly [TypeId, string]>
): boolean => {
  if (filterEntries.length === 0) return true;
  if (!rowData?.cells) return false;

  for (const [typeId, filterValue] of filterEntries) {
    if (!filterValue) continue;

    const cellValue = rowData.cells[typeId]?.value;
    const displayValue = getCellDisplayValue(cellValue).toLowerCase();
    const filterLower = filterValue.toLowerCase();

    if (!displayValue.includes(filterLower)) {
      return false;
    }
  }

  return true;
};

type FilterArRowIdsByColumnFiltersParams = {
  rowIds: readonly ArRowId[];
  rowsDocs: ReadonlyMap<string, DocEntry<ArRowData>> | null;
  filterEntries: ReadonlyArray<readonly [TypeId, string]>;
};

function filterArRowIdsByColumnFilters({
  rowIds,
  rowsDocs,
  filterEntries,
}: FilterArRowIdsByColumnFiltersParams): ArRowId[] {
  if (filterEntries.length === 0 || !rowsDocs) return [...rowIds];

  const next: ArRowId[] = [];
  for (const rowId of rowIds) {
    const rowData = rowsDocs.get(rowId)?.data;
    if (rowMatchesFilters(rowData, filterEntries)) next.push(rowId);
  }
  return next;
}

export { filterArRowIdsByColumnFilters, rowMatchesFilters, getCellDisplayValue };
export type { FilterArRowIdsByColumnFiltersParams };
